import React from 'react';
import { motion } from 'framer-motion';
import { Check, Book, FileText, Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
const INCLUSIONS = [{
  category: 'MANUALES COMPLETOS',
  icon: Book,
  items: ['Manual de Reiki Nivel 1 (PDF)', 'Manual de Reiki Nivel 2 (PDF)', 'Manual de Reiki Nivel Maestría (PDF)', 'Guía de Símbolos Sagrados Ilustrada']
}, {
  category: 'MATERIAL DE PRÁCTICA',
  icon: FileText,
  items: ['Protocolos de Autosanación paso a paso', 'Guía de Posiciones de Manos', 'Plantillas de Registro de Sesiones', 'Meditaciones Guiadas (Audio MP3)']
}, {
  category: 'RECURSOS ADICIONALES',
  icon: Gift,
  items: ['Certificados Personalizables (Nivel 1, 2 y Maestría)', 'Guía de Cristales y Reiki', 'Manual de Reiki para Animales', 'Afirmaciones y Decretos Energéticos']
}];
export function WhatYouGetSection() {
  return <section className="py-24 px-4 bg-white" data-id="element-248">
      <div className="max-w-6xl mx-auto" data-id="element-249">
        <div className="text-center mb-16" data-id="element-250">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4" data-id="element-251">
            ¿Qué Incluye Tu MegaPack?
          </h2>
          <p className="text-xl text-gray-600" data-id="element-252">
            Todo lo que necesitás en un solo lugar
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-253">
          {INCLUSIONS.map((category, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-gray-50 rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-254">
              <div className="flex items-center gap-3 mb-6 border-b border-gray-200 pb-4" data-id="element-255">
                <category.icon className="w-6 h-6 text-violet-600" data-id="element-256" />
                <h3 className="font-bold text-lg text-gray-900 tracking-wide" data-id="element-257">
                  {category.category}
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-258">
                {category.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-259">
                    <div className="mt-1 bg-violet-100 rounded-full p-1 shrink-0" data-id="element-260">
                      <Check className="w-3 h-3 text-violet-600" data-id="element-261" />
                    </div>
                    <span className="text-gray-700" data-id="element-262">{item}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <div className="bg-violet-50 rounded-2xl p-8 max-w-3xl mx-auto text-center border border-violet-100 mb-12" data-id="element-263">
          <p className="text-gray-500 mb-2 line-through text-lg" data-id="element-264">
            Valor Real: $49.990
          </p>
          <p className="text-3xl md:text-4xl font-bold text-violet-700 mb-6" data-id="element-265">
            Todo esto incluido en tu MegaPack
          </p>
          <CTAButton text="¡SÍ, QUIERO TODO ESTO!" data-id="element-266" />
        </div>
      </div>
    </section>;
}